import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/app/view-cart/page.tsx");
